<template>
  <div>
    <vs-input
      name="code"
      class="w-full"
      :disabled="verifying"
      placeholder="XXXX"
      v-model="code"
      @keyup.enter="login"
    />

    <vs-button class="mt-6 w-full" :disabled="verifying" @click="login"
      >تایید</vs-button
    >

    <div class="bottom-bar mt-6">
      <vs-button
        v-if="timeLeftToSendCodeAgain <= 0"
        size="small"
        color="warning"
        @click="sendCodeAgain()"
        type="border"
        >ارسال مجدد</vs-button
      >
      <div v-else>{{ timeLeftToSendCodeAgain }} ثانیه تا ارسال مجدد</div>

      <vs-button size="small" color="success" @click="editPhone()" type="border"
        >ویرایش شماره موبایل</vs-button
      >
    </div>
  </div>
</template>

<script>
import authApiService from "../../services/api/AuthApiService";
import authService from "../../services/AuthService";

export default {
  props: {
    phone: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      code: "",
      verifying: false,
      timeLeftToSendCodeAgain: 0,
      timerID: null,
    };
  },
  methods: {
    async login() {
      this.verifying = true;
      this.$vs.loading();

      authApiService
        .verify(this.phone, this.code)
        .then((userData) => {
          /*
            access_token: ...
            user: {
              id: number
              name: string
              phone: string
              privileged: boolean
            }
            */
          authService.login({
            ...userData,
            phone: this.phone,
            privileged: userData.privileged,
          });
          this.$store.commit("auth/LOGIN");
        })
        .catch((err) => {
          let message = err.getErrorDescriptions();

          switch (err.status) {
            case 400:
              message =
                err.error.response.data.message || err.getErrorDescriptions();
              break;
            case 404:
              message = err.error.response.data.message || "کد وجود ندارد";
              this.code = "";
              break;
          }

          this.$vs.notify({
            text: message,
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => {
          this.verifying = false;
          this.$vs.loading.close();
        });
    },
    destroyTimer() {
      if (this.timerID) clearInterval(this.timerID);
    },
    editPhone() {
      this.$emit("edit-phone");
    },
    sendCodeAgain() {
      this.$vs.loading();

      authApiService
        .login(this.phone)
        .then(() => {
          this.setIntervalToSendCodeAgain();
        })
        .catch((err) => {
          let message = err.getErrorDescriptions();

          switch (err.status) {
            case 403:
              message = "شما اجازه دسترسی به این پنل را ندارید";
              break;
            case 404:
              message = "شماره همراه معتبر نیست";
              break;
          }
          this.$vs.notify({
            text: message,
            color: "danger",
            position: "bottom-center",
          });

          if (err.status === 403) {
            this.phone = "";
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    setIntervalToSendCodeAgain() {
      this.timeLeftToSendCodeAgain = 60;

      this.timerID = setInterval(() => {
        this.timeLeftToSendCodeAgain--;

        if (this.timeLeftToSendCodeAgain <= 0) {
          this.destroyTimer();
        }
      }, 1000);
    },
  },
  watch: {
    code(value) {
      if (value.length === 4) {
        this.login();
      }
    },
  },
  mounted() {
    this.setIntervalToSendCodeAgain();
  },
  destroyed() {
    this.destroyTimer();
  },
};
</script>

<style lang="scss">
.bottom-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
